import moment from "moment";
export var formatDateTime = function (dateString) {
    if (!dateString)
        return "N/A";
    return moment(dateString).format("DD.MM.YYYY HH:mm");
};
/**
 * Formats a date as DD.MM.YYYY. A missing date (empty, undefined or null) renders as an empty
 * string rather than moment's "Invalid date" (or, for undefined, today's date).
 */
export var formatDate = function (dateString) {
    if (!dateString)
        return "";
    return moment(dateString).format("DD.MM.YYYY");
};
